import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'libero-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.scss'],
  standalone: false
})
export class ToggleSwitchComponent implements AfterViewInit {
  @Input() public formName!: AbstractControl;
  @Input() public disabled?: boolean;

  @ViewChild('toggleCheckbox') public checkbox!: ElementRef;

  public get value(): boolean {
    return this.formName.value;
  }

  public set value(value: boolean) {
    if(this.disabled) {
      return;
    }

    this.formName?.patchValue(!!value);
    this.formName?.markAsTouched();
    this.formName?.markAsDirty();
  }

  public ngAfterViewInit(): void {
    if(!this.formName) {
      this.formName = new UntypedFormControl(false);
    }
  }
}
